import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpParams,
  HttpResponse,
  HttpErrorResponse
} from "@angular/common/http";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { throwError } from 'rxjs';
declare let gtag: Function;


@Injectable({
  providedIn: "root"
})
export class GenericHttpService {
  constructor(private http: HttpClient, private toastr: ToastrService) {}

  httpRequest(config) {
    const httpOptions = {};

    if (!config["skipAuthorization"]) {
      httpOptions["withCredentials"] = true;
    }
    httpOptions["withCredentials"] = false;
    if (config["query"]) {
      httpOptions["params"] = config["query"];
    }

    if (config["body"]) {
      httpOptions["body"] = config["body"];
    }
    if (config["headers"]) {
      httpOptions["headers"] = config["headers"];
    }
    if (config["excludeToken"]) {
      httpOptions["excludeToken"] = config["excludeToken"];
    }
    // httpOptions['headers']['Content-Type'] = 'undefined';
    return this.http.request(config.method, config.url, httpOptions);
  }
  private queryParams(obj: Object) {
    const params = Object.keys(obj)
      .reduce((val, key) => {
        if (Array.isArray(obj[key])) {
          obj[key].forEach(function(value) {
            val.push(`${key}=${value}`);
          });
        } else {
          val.push(`${key}=${encodeURIComponent(obj[key])}`);
        }

        return val;
      }, [])
      .join("&");

    return new HttpParams({ fromString: params });
  }

  handleError(error: HttpErrorResponse) {
    let errMsg: string;
    let errLog: string;
    if (error instanceof HttpErrorResponse) {
      errMsg =
        error &&
        error["error"] &&
        Array.isArray(error["error"]["errors"]) &&
        error["error"]["errors"].length
          ? error["error"]["errors"]
          : error["error"];
    } else {
      errMsg = error["message"] ? error["message"] : error;
    }
    const err =  error.message? error.message :JSON.stringify(errMsg);
    errLog = 'HTTP ERROR - Status-' + error.status + ' Description- ' + err;
    gtag('event', 'exception', {
      'description': errLog,
      'fatal': true
    });

    return throwError(errMsg);//Observable.throw();
  }

  /**
   *
   * Read response and convert it to JSON.
   *
   **/
  responseData(res: HttpResponse<any>) {
    const body = res;
    return body || {};
  }

  showErrorToastr(error) {
    if (error.length) {
      error.map(errorMessage => this.toastr.error(errorMessage.error_message));
    } else {
      this.toastr.error(error[0].error_message);
    }
  }
}
